import apiClient from '../../../shared/api/client';
import { Purchase, PaginatedResponse } from '../types/purchase.types';

class PurchaseService {
  private readonly baseUrl = '/purchases';

  /**
   * Get paginated purchases for the current user
   * @param params - Optional pagination parameters
   * @returns Paginated purchases with offer details
   */
  async getMyPurchases(params?: {
    page?: number;
    limit?: number;
  }): Promise<PaginatedResponse<Purchase>> {
    const query = new URLSearchParams();
    if (params?.page !== undefined) query.set('page', String(params.page));
    if (params?.limit !== undefined) query.set('limit', String(params.limit));
    const qs = query.toString();
    return await apiClient.get<PaginatedResponse<Purchase>>(
      `${this.baseUrl}/me${qs ? `?${qs}` : ''}`
    );
  }

  /**
   * Get a specific purchase by ID
   * @param id - Purchase ID
   * @returns Purchase details
   */
  async getPurchaseById(id: string): Promise<Purchase> {
    return await apiClient.get<Purchase>(`${this.baseUrl}/${id}`);
  }

  /**
   * Register buyer interest in an offer (creates a purchase record; offer stays PUBLISHED)
   * @param offerId - ID of the offer
   * @returns Created purchase record
   */
  async interestOffer(offerId: string): Promise<Purchase> {
    return await apiClient.post<Purchase>(`${this.baseUrl}/offers/${offerId}/interest`);
  }
}

export default new PurchaseService();
